var map = {
	"./image1.webp": 14999,
	"./image2.webp": 90497,
	"./image3.webp": 95669,
	"./image4.webp": 36058,
	"./image5.webp": 24036,
	"./image6.webp": 10652,
	"./image7.webp": 70853,
	"./image8.webp": 13745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5554;